import changeCopyright from "@/utils/config/changeCopyright";

export default {
  data() {
    return {
      ...changeCopyright,
      level: 1,
      vipExpireTime: "",
    };
  },
  created() {
    this.checkAppIdentity();
  },
  beforeDestroy() {},

  methods: {
    checkAppIdentity() {
      this.level = localStorage.getItem("rightsLevel") || 1;
      this.vipExpireTime = localStorage.getItem("vipExpireTime") || "";
      console.log("level:", this.$data, "vipExpireTime:", this.vipExpireTime);
    },
  },
};
